import createEditSmsSystemRedux from 'Modules/smsSystems/views/.components/createEditSmsSystem/redux/reducer';
import deleteSmsSystemRedux from 'Modules/smsSystems/views/.components/deleteSmsSystem/redux/reducer';

//export redux objects
export default {
	createEditSmsSystemRedux,
	deleteSmsSystemRedux,
};